export function resolveAttributeName(attributeName) {
    if (attributeName) {
        // Attribute names are case-insensitive, but _should_ be lower case.
        return attributeName.toLowerCase();
    }
    return undefined;
}
